<template>
    <v-card flat class="mb-3">
        <div>
            <v-layout row wrap>
                <v-flex xs12 lg8 offset-lg2>
                    <v-card flat class="mt-3 pa-1" v-if="inputData">
                        <v-form ref="form">
                            <v-flex xs12 >
                                <v-layout row wrap>
                                    <v-flex xs12 md6>
                                        <v-select
                                                class="pa-3"
                                                v-model="type"
                                                color="deep-purple accent-3"
                                                :rules="formRules"
                                                item-text="name"
                                                item-value="id"
                                                :items="inputData.types"
                                                label="Veids"
                                        ></v-select>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-autocomplete
                                                clearable
                                                class="pa-3"
                                                v-model="owner"
                                                color="deep-purple accent-3"
                                                item-text="name"
                                                item-value="id"
                                                :items="inputData.companies"
                                                label="Īpašnieks"
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>

                            </v-flex>

                            <v-flex xs12 >
                                <v-layout row wrap>
                                    <v-flex xs12 md6>
                                       <v-text-field
                                               class="pa-3"
                                               v-model="regNr"
                                               label="Reģistrācijas Nr."
                                               color="deep-purple accent-3"
                                               :rules="formRules"
                                               required>
                                       </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-text-field
                                                class="pa-3"
                                                v-model="year"
                                                label="Ražošanas gads"
                                                color="deep-purple accent-3"
                                                >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>

                            </v-flex>


                            <v-flex xs12 >
                                <v-layout row wrap>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                                class="pa-3"
                                                v-model="manufacturer"
                                                label="Ražotājs"
                                                color="deep-purple accent-3"
                                                >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-text-field
                                                class="pa-3"
                                                v-model="model"
                                                label="Modelis"
                                                color="deep-purple accent-3"
                                                >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>

                            </v-flex>

                            <v-layout row wrap>
                                <v-flex xs12 class="mx-3 mb-3">
                                    <div class="text-xs-center text-md-right">
                                        <v-btn small flat @click="hideAddContainerForm" dark color="deep-orange lighten-1">
                                            <v-icon dark left>block</v-icon>Atcelt</v-btn>
                                        <v-btn small flat @click="submit" dark color="green accent-4">Pievienot
                                            <v-icon dark right>check_circle</v-icon>
                                        </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card>
                </v-flex>
            </v-layout>

        </div>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "add-cleaning",
        data: () => ({
            owner: '',
            type: '',
            regNr: '',
            year: '',
            manufacturer: '',
            model: '',
            formRules: [
                v => !!v || 'Šis lauks ir obligāts',
            ],
        }),
        mounted() {
            this.$store.dispatch('getVehicleInputData')
        },
        computed: {
            ...mapGetters({
                inputData: 'vehicleInputData'
            })
        },
        methods: {
            hideAddContainerForm(){
                this.$store.dispatch('hideAddVehicleForm')
            },
            submit(){
                this.$Progress.start()
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('createNewVehicle', {
                        regNr: this.regNr,
                        year: this.year,
                        ownerId: this.owner,
                        typeId: this.type,
                        manufacturer: this.manufacturer,
                        model: this.model,
                    })
                    this.$parent.snackbar = true
                    this.$parent.color = 'green'
                    this.$parent.text = 'Transporta līdzeklis pievienots'
                }  else {
                    this.$Progress.fail()
                }
            },
        }
    }
</script>

<style scoped>

</style>